<template>
    <div class="m-task" v-if="$store.state.task">
        <h5 class="title"></h5>
        <div class="slogen">完成梦玩团相应任务，即可领取奖励；还有机会加入梦玩团大神扶持计划</div>
        <div class="page-detail">
            <div class="task-view">

                <div class="task-item" :class="item.clz" v-for="(item,index) in task_config" :key="'t-' + index">
                    <div class="task-bg"></div>
                    <div class="task-pannel">
                        <h6>{{ item.task_name }}</h6>
                        <div class="task-info">{{ item.task_name }}</div>
                        <div class="rate"><span>{{ $store.state.task[item.tid].rate }} </span>/ {{ item.max }}</div>

                        <div class="reward-list">
                            <ul>
                                <li v-for="(r,k) in item.gift_list" :key="k">
                                    <div class="reward-item" v-tips="r.id"><game-item :locked="true" :id="r.id" :num="r.send_num"></game-item></div>
                                </li>
                            </ul>
                        </div>

                        <div class="u-btn apply disabled" v-if="!$store.state.task[item.tid].isCompleted"></div>
                        <div class="u-btn apply" v-else :class="{'disabled' : !$store.state.task[item.tid].isCompleted,'dismiss' : $store.state.task[item.tid].isSubmit}"
                        @click="apply($store.state.task[item.tid].taskOrderId,item.gift_list)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 799px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-1.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-1.png);
        }         
    }

    .task-view{
        @if ( $screenWidth == 1600) {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;

        }@else if( $screenWidth == 1000 ) {
            margin-top: 20px;
        }            
    }

    .task-item{
        @if ( $screenWidth == 1600) {
            position: relative;
            width: 582px;
            height: 357px;

            .task-pannel{
                position: relative;
                z-index: 2;

                h6{
                    width: 216px;
                    height: 27px;
                    margin: 0 auto 20px;
                    font-size: 0;
                    color: transparent;
                }

                .task-info{
                    margin-bottom: 20px;
                    text-align: center;
                }

                .rate{
                    margin-bottom: 16px;
                    font-size: 20px;
                    text-align: center;

                    span{
                        color: #c2393f;
                    }
                }

                .reward-list{

                    margin-bottom: 36px;

                    ul{
                        display: flex;
                        justify-content: space-between;
                    }

                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 64px;
                        height: 64px;
                        border: 1px solid #d1c7b4;
                        background-color: #e6ddcc;
                    }

                    .reward-item{
                        width: 46px;
                        height: 46px;
                    }
                }

                .u-btn.apply{
                    width: 207px;
                    height: 55px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/btn-apply.png);

                    &.disabled{
                        background-image: url(~@/assets/images/pc/btn-apply_disabled.png);

                        &:hover{
                            background-image: url(~@/assets/images/pc/btn-apply_disabled.png);
                        }
                    }

                    &.dismiss{
                        background-image: url(~@/assets/images/pc/btn-apply-ok-an.png);

                        &:hover{
                            background-image: url(~@/assets/images/pc/btn-apply-ok-an.png);
                        }
                    }                    

                    &:hover{
                        background-image: url(~@/assets/images/pc/btn-apply_hover.png);
                    }
                }
            }

            &.left{

                .task-bg{
                    position: absolute;
                    right: 0;
                    top: -87px;
                    width: 768px;
                    height: 444px;
                    background-image: url(~@/assets/images/pc/task-left.png);
                }

                .task-pannel{
                    padding: 34px 50px 0 247px;
                }

                h6{
                    background-image: url(~@/assets/images/pc/task-1.png);
                }
            }

            &.right{

                .task-bg{
                    position: absolute;
                    left: 0;
                    top: -121px;
                    width: 810px;
                    height: 478px;
                    background-image: url(~@/assets/images/pc/task-right.png);
                }

                .task-pannel{
                    padding: 34px 247px 0 50px;
                }
                
                h6{
                    background-image: url(~@/assets/images/pc/task-2.png);
                }                
            }

        }@else if( $screenWidth == 1000 ) {
            position: relative;
            width: 711px;
            height: 367px;
            margin: 0 auto 33px;

            .task-pannel{
                position: relative;
                z-index: 2;

                h6{
                    width: 320px;
                    height: 40px;
                    margin: 0 auto 20px;
                    font-size: 0;
                    color: transparent;
                    background-position: top center;
                    background-repeat: no-repeat;
                }

                .task-info{
                    margin-bottom: 20px;
                    text-align: center;
                }

                .rate{
                    margin-bottom: 16px;
                    font-size: 30px;
                    text-align: center;

                    span{
                        color: #c2393f;
                    }
                }

                .reward-list{

                    margin-bottom: 25px;

                    ul{
                        display: flex;
                        justify-content: space-between;
                    }

                    li{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 87px;
                        height: 87px;
                        border: 1px solid #d1c7b4;
                        background-color: #e6ddcc;
                    }

                    .reward-item{
                        width: 69px;
                        height: 69px;
                    }
                }

                .u-btn.apply{
                    width: 207px;
                    height: 55px;
                    margin: 0 auto;
                    background-image: url(~@/assets/images/pc/btn-apply.png);

                    &.disabled{
                        background-image: url(~@/assets/images/m/btn-apply-an.png);
                    }

                    &.dismiss{
                        background-image: url(~@/assets/images/m/btn-apply-ok-an.png);

                    }     

                }
            }

            &.left{

                .task-bg{
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 711px;
                    height: 367px;
                    background-image: url(~@/assets/images/m/task-left.png);
                }

                .task-pannel{
                    padding: 22px 50px 0 311px;
                }

                h6{
                    background-image: url(~@/assets/images/m/task-1.png);
                }
            }

            &.right{

                .task-bg{
                    position: absolute;
                    left: 0;
                    top: -68px;
                    width: 711px;
                    height: 435px;
                    background-image: url(~@/assets/images/m/task-right.png);
                }

                .task-pannel{
                    padding: 22px 50px 0 311px;
                }
                
                h6{
                    background-image: url(~@/assets/images/m/task-2.png);
                }                
            }
        }       
    }

    @if ( $screenWidth == 1600) {

    }@else if( $screenWidth == 1000 ) {

    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<script>
export default {
    data (){
        return {
            task_config : [
                {
                    tid : 't01',
                    task_name : '完成1次绑定或接受他人绑定',
                    max : 1,
                    clz : 'left',
                    gift_list : [
                        {"id":"D774","item_name":"暗金珍材自选宝箱","send_num":1},
                        {"id":"KR48","item_name":"活跃自选礼包（7天）","send_num":2},
                        {"id":"ZI98","item_name":"好感玉","send_num":20},                        
                    ],
                },{
                    tid : 't02',
                    task_name : '获得返利超10000绑定梦三币',
                    max : 10000,
                    clz : 'right',
                    gift_list : [
                        {"id":"X615","item_name":"臻选暗金封灵玉宝匣","send_num":1},
                        {"id":"LP76","item_name":"暗金武器超级成长包","send_num":1},
                        {"id":"KE06","item_name":"梦玩团*卓尔不凡（30天）","send_num":1}                        
                    ],                 
                }
            ]
        }
    },
    methods : {
        apply (tid,list){
            if(!this.$store.state.login){
                return this.$mslogin.open();
            }
            if(!this.$store.state.userinfo.areaId){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            if(!tid){
                return this.$toast('请先完成任务');
            }

            this.$axios.post(ajax_url_map.apply_task,{
                no : tid
            })
            .then(
                res => {
                    this.$reward_success({giftList : list});
                    this.$task_render();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/task.vue